module.exports = __webpack_public_path__ + "static/media/crown.169745c0.png";